import { render, staticRenderFns } from "./FlipAndRotate.vue?vue&type=template&id=9670b554&"
import script from "./FlipAndRotate.vue?vue&type=script&lang=ts&"
export * from "./FlipAndRotate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports